<template>
    <div class="trajectory">
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="20">
                <el-collapse
                    v-show="mainlist"
                    v-model="activeNames"
                    @change="handleChange"
                    accordion
                >
                    <el-collapse-item
                        v-for="(item, index) in mainlist"
                        :key="index"
                        :title="item.title"
                        :name="index"
                    >
                        <div v-html="item.content"></div>
                    </el-collapse-item>
                </el-collapse>
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="ruleForm.pageIndex"
                    :page-size="ruleForm.pageSize"
                    layout="total,prev, pager, next"
                    :total="ruleForm.total"
                >
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { selectfaq } from "@/api/homePage";
export default {
    name: "trajectory",
    data() {
        return {
            activeNames: [0],
            mainlist: [],
            ruleForm: {
                data: {
                    categoryId: "",
                    platform: "1"
                },
                pageIndex: 1,
                pageSize: 5,
                total: 0
            }
        };
    },
    created() {
        this.ruleForm.data.categoryId = "0";
        this.search(1);
    },
    methods: {
        handleChange() {},
        search(val) {
            this.ruleForm.pageIndex = val;
            selectfaq(this.ruleForm).then(res => {
                if (res.status === 2000) {
                    this.mainlist = res.data.rows;
                    this.ruleForm.total = res.data.total;
                }
            });
        },
        handleCurrentChange(val) {
            this.search(val);
        }
    }
};
</script>

<style scoped lang="scss">
.trajectory {
    .el-row {
        margin-top: 40px;
        margin-bottom: 80px;
        .el-collapse-item__content {
            font-size: 14px;
        }
    }
    .el-pagination {
        text-align: center;
        margin-top: 30px;
    }
    /deep/ .el-pagination.is-background .el-pager li {
        border-radius: 15px;
    }
    /deep/ .el-pagination.is-background .btn-prev,
    /deep/ .el-pagination.is-background .btn-next {
        border-radius: 15px;
    }
}
</style>
